import React from 'react';
import BuscadorApp from "../components/BuscadorApp";

export default function HomePage() {
  return (
    <BuscadorApp />
  )
}